var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Functions = OCS.Functions || {};
OCS.Functions.define_meteogram_export_class = function () {
    OCS.Classes.MeteogramExport = new Class({
        Extends: OCS.Classes.ExportGraph,
        svg_array: [],
        chart_height: 0,
        chart_width: 0,
        process_image_export: function () {
            this.callback = this.download_svg.bind(this);
            if (this.svg_array.length !== Object.keys(this.charts).length) {
                Object.each(this.charts, function (chart, i) {
                    chart.set_export_options(this.get_export_options());
                    chart.request_svg(this.svg_recieved.bind(this));
                }, this);
            }
        },
        process_text_export: function () {
            if (this.charts) {
                var series = [];
                Object.each(this.charts, function (chart, i) {
                    chart.create_series_array();
                    series.combine(chart.get_series_array());
                }, this);
                this.create_x_axis_array();
                var options = {
                    chart: {
                        animation: false,
                        forExport: true,
                        renderer: 'SVGRenderer',
                        renderTo: this.options.chart.renderTo + '_export'
                    },
                    xAxis: this.x_axis_array,
                    yAxis: [{}, {}],
                    exporting: {enabled: false},
                    series: series
                };
                var export_chart = new Highcharts.Chart(options);


                switch (this.options.type.split('/')[1]) {
                    case 'csv':
                        export_chart.downloadCSV();
                        break;
                    default:
                        export_chart.downloadXLS();
                        break;
                }
                export_chart.destroy();

            }
        },
        export_chart_complete: function () {
            if (this.callback && this.svg_array.length === Object.keys(this.charts).length) {
                this.svg = '<svg height="' + this.chart_height + '" width="' + this.chart_width + '" version="1.1" xmlns="http://www.w3.org/2000/svg">' + this.svg_array.join('') + '</svg>';
                this.svg_array = [];
                this.callback(this.svg, this);
                // Important to clear chart height so future exports will work properly
                this.chart_height = 0;
            }
        },
        svg_recieved: function (svgres, chart) {
            if (svgres) {
                svgres = svgres.replace(/<g class="highcharts-tooltip"(.|\n)+<\/g>/g, '');
                svgres = svgres.replace(/<svg([^>]+)/g, '<svg');
                var svg = svgres.replace('<svg', '<g transform="translate(0,' + this.chart_height + ')" ');
                svg = svg.replace('</svg>', '</g>');
                this.svg_array.push(svg);
                this.chart_height += chart.get_chart_height();
                this.chart_width = Math.max(this.chart_width, chart.get_chart_width());
                this.export_chart_complete();
            }
        }
    });
};
OCS.Functions.define_meteogram_export_class();